import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../locales/en/translation.json";
import nl from "../locales/nl/translation.json";
import axios from "axios";

const savedLanguage = localStorage.getItem("language" || "nl");

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            nl: { translation: nl },
        },
        lng: savedLanguage,
        fallbackLng: "nl",
        interpolation: {
            escapeValue: false,
        },
    });

i18n.on("languageChanged", (lng) => {

    axios.defaults.headers.common["Accept-Language"] = lng;

    document.documentElement.lang = lng;
    localStorage.setItem("language", lng);
});

const initialLang = localStorage.getItem("language") || "nl";
axios.defaults.headers.common["Accept-Language"] = initialLang;
// apiClient.defaults.headers.common["Accept-Language"] = initialLang;
document.documentElement.lang = initialLang;

export default i18n;

